import { jsxs, jsx } from "react/jsx-runtime";
const IconRocketSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M20.958 3.042a2.004 2.004 0 0 0-1.963-.51l-3.276.937a9.011 9.011 0 0 0-3.892 2.29L9.53 8.057l-6.67.953a.999.999 0 0 0-.566 1.697L4.586 13 11 19.414l2.293 2.293a1 1 0 0 0 1.697-.565l.953-6.671 2.298-2.298a9.011 9.011 0 0 0 2.29-3.892l.937-3.276a2.004 2.004 0 0 0-.51-1.963ZM5.121 10.707l2.05-.293L6 11.586l-.879-.879Zm8.172 8.172L12.414 18l1.172-1.172-.293 2.05Zm5.314-11.147a7.006 7.006 0 0 1-1.78 3.027L11 16.586 7.414 13l5.827-5.827a7.006 7.006 0 0 1 3.027-1.78l3.276-.937-.937 3.276Zm-11.9 9.561a1 1 0 0 0-1.414 0l-2 2a1 1 0 1 0 1.414 1.414l2-2a1 1 0 0 0 0-1.414Zm-3-.586 1-1a1 1 0 1 0-1.414-1.414l-1 1a1 1 0 1 0 1.414 1.414Zm4.586 2.586-1 1a1 1 0 1 0 1.414 1.414l1-1a1 1 0 1 0-1.414-1.414Z" })
    ]
  }
);
export {
  IconRocketSvg
};
